import React from 'react';
import {
  Container, Row, Col,
} from 'reactstrap';
import classnames from 'classnames';

import {
  Intl, Form, TextField, FormActionsBtns,
} from 'components';
import { formatNumeral } from 'utils';
import { composeValidators, required, lessThanOrEqual } from 'config/InputErrors';

export default ( {
  data, isLoading, ownerCredit, parentPath, onSubmit,
} ) => (
  <Container
    fluid
    className={classnames( { 'app-component-loading': isLoading } )}
  >
    <Row>
      <Col>
        <span className="text-gray-7">
          <Intl id="assignCreditTo" />
          {' '}
          {data.firstName}
          {' '}
          {data.lastName}
        </span>
      </Col>
    </Row>
    <Row>
      <Col>
        <span className="text-sm">
          {!!data.id && (
            <>
              <Intl
                id="enterAmountToAssign"
                values={{ value: formatNumeral( ownerCredit ) }}
              />
              :
            </>
          )}
        </span>
      </Col>
    </Row>
    <Form
      initialValues={data}
      showErrorsInHeader
      onSubmit={onSubmit}
      body={() => (
        <>
          <Row className="mt-3 mb-5">
            <Col md={3} className="m-auto">
              <Row>
                <Col md>
                  <TextField
                    type="number"
                    field="amount"
                    inputClassName="bg-mp-orange-7"
                    formGroupClass="m-0"
                    validate={composeValidators( required, lessThanOrEqual( ownerCredit ) )}
                    validateTranslateValues={{ label: ownerCredit }}
                  />
                </Col>
                <Col md="auto" className="pl-md-0 mt-1 text-sm">
                  <Intl id="euros" />
                </Col>
              </Row>
            </Col>
          </Row>
        </>
      )}
      footer={( <FormActionsBtns saveLabel="save" cancelTo={parentPath} /> )}
    />
  </Container>
);
